import AnimatedComponent from "../marketing-site/animated-component/AnimatedComponent";

export function Header() {
  return (
    <div className="container container-fluid">
      <div className="row align-items-center">
        <div className="col-sm-6">
          <h2 className="h1">
            Purr <span className="underline">Blog</span>
          </h2>
          <p className="font-20">
            Dive into Purr's Blog for insider car-buying tips, the latest Purr
            news, and industry best practices. Whether you're a first-time buyer
            or a seasoned enthusiast, find everything you need to make informed
            decisions and drive away happy.
          </p>
        </div>
        <div className="col-sm-6">
          <div className="hero">
            <AnimatedComponent path="/marketing-assets/animations/heros/seller.json" />
          </div>
        </div>
      </div>
    </div>
  );
}
